import React, { PureComponent } from 'react';
import { Container, Row } from 'reactstrap';

import PropertySearchAdvancedForm from './PropertySearchAdvancedForm';

class PropertySearchAdvanced extends PureComponent {
  render() {
    const {
      onChange,
      onSubmit,
      initialValues,
      propertyClass,
      pathname,
      pathnameResults
    } = this.props;

    return (
      <Row>
        <Container>
          <PropertySearchAdvancedForm
            enableReinitialize={true}
            initialValues={initialValues}
            onChange={onChange}
            onSubmit={onSubmit}
            propertyClass={propertyClass}
            pathname={pathname}
            pathnameResults={pathnameResults}
          />
        </Container>
      </Row>
    );
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
}

export default PropertySearchAdvanced;



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertySearchAdvanced.js